module.exports = __webpack_public_path__ + "img/green_133.29e19b70.png";